import type { ReactNode } from 'react';

export const symbol_movie_info: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-120q-24 0-42-18t-18-42v-599q0-24 18-42.5t42-18.5h681q24.34 0 41.67 18.5Q880-803 880-779v599q0 24-17.33 42T821-120H140Zm361.5-182.63q8.5-8.62 8.5-21.37v-173q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v173q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63ZM480.18-613q12.82 0 21.32-8.68 8.5-8.67 8.5-21.5 0-12.82-8.68-21.32-8.67-8.5-21.5-8.5-12.82 0-21.32 8.68-8.5 8.67-8.5 21.5 0 12.82 8.68 21.32 8.67 8.5 21.5 8.5ZM305-180h352v-599H305v599Zm0-599h352-352ZM140-180h105v-105H140v105Zm576 0h105v-105H716v105ZM140-344h105v-105H140v105Zm576 0h105v-105H716v105ZM140-509h105v-105H140v105Zm576 0h105v-105H716v105ZM140-674h105v-105H140v105Zm576 0h105v-105H716v105Z"
		/>
	</svg>
);
